
<script>
import BarList from '../components/bar-list'
import FilialForm from './filial-form'
import AppCertificado from './app-certificado'
import axios from 'axios'
import { apiORDS, apiORDSpost, apiORDSapp, apiORDSmidia, urlORDS } from '../shared/api-functions'
import { getText, formatDate, formatValue } from '../shared/utils'
import { SysVars } from '../main';

export default {
    data () {

        return {
            showForm: false, //exibe a tela de manutencao
            showFormCert: false, //exibe a tela de manutencao do certificado
            showFormLogo: false, //exibe a tela de manutencao do logotipo
            filial: '',
            codfil: '',
            metadata: this.$store.getters.getEntities.metadata,
            filter: '',
            offset: '',
            inicio: true,
            file: {},
            urlImage: '',
            selectedFile: '',
            filialList: {},
            operacao: {},
        }
    },

    computed: {
        nextPage: function () {
            return this.$store.getters.getNextPage
        },

        appForcaVendas: function () {
            return SysVars.appForcaVendas
        },

        usuario: function () {
            return this.$store.getters.getEnv.uuid
        },

    },


    filters: {
        getText: function (value, metadata) {
            return getText(value, metadata)
        },
    },

    methods: {
        handleGuiaInstalacaoCertificado(cod) {
            //EXIBE O GUIA DE INSTALACAO DO CERTIFICADO DIGITAL
            this.codfil = cod
            this.showFormCert = true
        },

        handleClickLogotipo(cod) {
            this.$refs.file.value = ''
            this.codfil = cod
            this.$refs.file.click()
            //document.getElementById('fileInput').click()
        },


        handleUpload (event) {
            this.selectedFile = event.target.files[0] //this.$refs.file.files[0]
            this.urlImage = URL.createObjectURL(this.selectedFile)
            this.uploadImage()
        },

        handleEdit (cod) {
            //abre a tela de edicao
            this.crud = SysVars.crudU;
            this.codfil = cod
            this.showForm = true;
        },

        handleNew () {
            //inclusao de registro
            this.crud = SysVars.crudI
            this.codfil = ''
            this.showForm = true;
        },

        handleMore () {
            this.offset = 'offset=' + this.nextPage
            this.loadData()
        },

        closeForm() {
            this.showForm = false
            this.showFormCert = false
            this.showFormLogo = false
            this.$scrollTo(0)
            this.loadData()
        },

        search(value) {
            //efetua a pesquisa
            this.filter = '{"$or":[{"codfil":{"$like":"%25' + value + '%25"}},{"nome":{"$like":"%25' + value + '%25"}}]}'
            this.loadData()
        },

        async loadLogoTipo(x) {
            let self = this
            let test = x

            await apiORDSmidia(this.$store.getters.urlApp + 'logo/download/' + this.filialList[x].codempresa + '/' + this.filialList[x].codfil).then(
                data => {
                    if (data && data.size > 0) {
                        let reader = new window.FileReader();
                        reader.readAsDataURL(data);
                        reader.onload = function() {
                            self.filialList[test].urlimage = reader.result;
                        }
                    }
                }
            )
        },

        async loadData() {
            await this.$store.dispatch('loadFilial', { filter: this.filter } )
            this.filialList = [...this.$store.getters.getFilialList]
            if (this.inicio) {
                //FORÇA A INCLUSAO DE UMA FILIAL
                if (!this.filialList.length || this.filialList.length == 0) {
                    this.handleNew()
                // } else if (this.appForcaVendas) {
                    // this.handleEdit(1)
                }
                if (!this.appForcaVendas)
                  this.inicio = false
            }

            this.$nextTick(function () {
                jQuery('[data-toggle="tooltip"]').tooltip()
            })

            let self = this

            let test = 0

            for (var x = 0; x < this.filialList.length; x++) {
                this.$set(this.filialList[x], 'urlimage', null)
                this.loadLogoTipo(x)
            }


            //CARREGA O LOGOTIPO DA EMPRESA

        },

        data (value) {
            return formatDate(value)
        },

        uploadImage(){
            //EFETUA O UPLOAD DO CERTIFICADO

            let formData = new FormData();
            formData.append('file', this.selectedFile);

            var url = this.$store.getters.urlApp + 'logo/'

            var self = this

            axios.post(url, formData,
                {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'codfilial': this.codfil,
                    'filename': this.selectedFile.name
                }
            }
            ).then(function(data){
                    self.$erpToastSuccess('O logotipo foi atualizado com sucesso.')
                    self.closeForm()
            })

        },

        handleRemoverImagem(filial) {
            this.apiDeleteImage(filial)
        },

        async apiDeleteImage (filial) {
            //EFETUA A EXCLUSAO DO LOGOTIPO
            var modulo = 'logo/' + filial.codlogotipo
            const data = await apiORDSapp(this, modulo, 'delete')
            filial.urlimage = null
            this.$erpToastSuccess('O Logotipo foi removido com sucesso.')
        },

    },

    components: {
        BarList, FilialForm, AppCertificado
    },

    created () {
        this.showForm = false
        var self = this;
        this.loadData().then(function (){
            if (self.$route.params && self.$route.params.operacao) {
                self.operacao = self.$route.params.operacao //numero do pedido de venda

                if (self.operacao == 'certificado' && self.filialList.length && self.filialList.length > 0) {
                    self.handleGuiaInstalacaoCertificado(self.filialList[0].codfil)
                }

            }

        })


    }

}

</script>

<template>
    <div>
        <div id="list" v-show="!showForm && !showFormCert">
            <bar-list
                v-if="!appForcaVendas"
                :refresh-button="true"
                :new-button="false"
                :pdf-button="false"
                :xls-button="false"
                single-entity="Empresa"
                plural-entity="Empresas"
                @search="search"
                @new="handleNew"
                @refresh="loadData"
                title-search="Pesquise pelo nome"
                videoButton="true"
                video-icon="fa-youtube-play"
                urlVideo="//www.youtube.com/embed/0QMVqSEm-ww">
            </bar-list>
            <br>
            <div class="nb-filial-list">
                <div v-if="filialList.length == 0">
                    <alert type="warning" text="Nenhuma Filial foi encontrada."></alert>
                </div>
                <article class="nb-filial-card" v-for="(filial, index) in filialList" :key="filial.codfil || index">
                    <div class="nb-filial-card-main">
                        <div class="nb-filial-identity">
                            <div class="nb-filial-logo-wrap">
                                <button type="button" class="nb-filial-logo" title="Selecionar logotipo"
                                    :aria-label="'Selecionar logotipo para ' + filial.nome"
                                    @click="handleClickLogotipo(filial.codfil)">
                                    <img v-if="filial.urlimage" :src="filial.urlimage" alt="">
                                    <i v-else class="fa fa-building-o" aria-hidden="true"></i>
                                    <span class="nb-filial-logo-edit"><i class="fa fa-camera" aria-hidden="true"></i></span>
                                </button>
                                <button v-if="filial.urlimage" type="button" class="nb-filial-logo-remove"
                                    title="Remover logotipo" :aria-label="'Remover logotipo de ' + filial.nome"
                                    @click="handleRemoverImagem(filial)">
                                    <i class="fa fa-trash" aria-hidden="true"></i>
                                </button>
                            </div>
                            <div class="nb-filial-info">
                                <h2>{{ filial.nome }}</h2>
                                <div class="nb-filial-meta">
                                    <span v-if="filial.cnpj">CNPJ/CPF {{ filial.cnpj | formatCNPJCPF }}</span>
                                    <span v-if="filial.codfil" class="nb-filial-code">Filial {{ filial.codfil }}</span>
                                </div>
                            </div>
                        </div>

                        <div class="nb-filial-statuses">
                            <span v-if="filial.tpambnfe == '1'" class="nb-filial-badge nb-filial-badge--production">
                                <i class="fa fa-circle" aria-hidden="true"></i> Produção
                            </span>
                            <span v-else-if="filial.tpambnfe == '2'" class="nb-filial-badge nb-filial-badge--homologation">
                                <i class="fa fa-circle" aria-hidden="true"></i> Homologação
                            </span>
                            <span v-else class="nb-filial-badge nb-filial-badge--neutral">Ambiente não definido</span>

                            <span v-if="filial.cert_pendente == 'S'" class="nb-filial-badge nb-filial-badge--pending">
                                <i class="fa fa-exclamation-circle" aria-hidden="true"></i> Certificado pendente
                            </span>
                            <span v-else-if="filial.cert_vencido == 'S'" class="nb-filial-badge nb-filial-badge--expired">
                                <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Certificado vencido
                            </span>
                            <span v-else class="nb-filial-badge nb-filial-badge--active">
                                <i class="fa fa-check-circle" aria-hidden="true"></i> Certificado ativo
                            </span>
                        </div>

                        <div class="nb-filial-actions">
                            <div class="nb-filial-action">
                                <v-button :label="filial.cert_pendente == 'S' ? 'Configurar certificado' : (filial.cert_vencido == 'S' ? 'Renovar certificado' : 'Certificado')"
                                    icon="fa-id-card" :nb-btdef="filial.cert_pendente == 'S' || filial.cert_vencido == 'S'"
                                    @click="handleGuiaInstalacaoCertificado(filial.codfil)"></v-button>
                            </div>
                            <div class="nb-filial-action">
                                <v-button label="Editar" icon="fa-pencil" @click="handleEdit(filial.codfil)"></v-button>
                            </div>
                        </div>
                    </div>
                </article>

            </div>
        </div>
        <div class="row">
            <input v-show="false" type="file" ref="file" accept="image/*" @change="handleUpload($event)">
        </div>


        <div v-if="showForm" class="modal nb-modal-mask" style="display:block; z-index: 1 !important;" @keyup.esc="closeModal()">
            <div class="modal-dialog modal-dialog-centered modal-full-w" role="document">
                <div class="modal-content modal-full-h" style="">
                    <div class="modal-body" style="">
                        <filial-form :index="codfil" :crud="this.crud" v-on:closeform="closeForm"></filial-form>
                    </div>
                </div>
            </div>
        </div>



        <!-- TELA MODAL PARA IMPORTACAO DE CERTIFICADO -->
        <div v-if="showFormCert">
            <app-certificado :codfil="codfil" @closeform="closeForm"></app-certificado>
        </div>
    </div>
</template>

<style>
.nb-filial-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.nb-filial-card {
    padding: 16px 18px;
    background: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    box-shadow: 0 1px 3px rgba(15, 23, 42, 0.04);
    transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.nb-filial-card:hover {
    border-color: #cbd5e1;
    box-shadow: 0 4px 12px rgba(15, 23, 42, 0.06);
}

.nb-filial-card-main {
    display: grid;
    grid-template-columns: minmax(260px, 1fr) auto auto;
    align-items: center;
    gap: 18px;
}

.nb-filial-identity {
    display: flex;
    min-width: 0;
    align-items: center;
    gap: 14px;
}

.nb-filial-logo-wrap {
    position: relative;
    flex: 0 0 58px;
    width: 58px;
    height: 58px;
}

.nb-filial-logo {
    display: flex;
    width: 58px;
    height: 58px;
    align-items: center;
    justify-content: center;
    padding: 5px;
    color: #64748b;
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    cursor: pointer;
}

.nb-filial-logo:focus-visible,
.nb-filial-logo-remove:focus-visible {
    outline: 2px solid #004e94;
    outline-offset: 2px;
}

.nb-filial-logo > img {
    display: block;
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
}

.nb-filial-logo > .fa {
    font-size: 24px;
}

.nb-filial-logo-edit {
    position: absolute;
    right: -4px;
    bottom: -4px;
    display: flex;
    width: 21px;
    height: 21px;
    align-items: center;
    justify-content: center;
    color: #fff;
    background: #004e94;
    border: 2px solid #fff;
    border-radius: 50%;
    font-size: 9px;
}

.nb-filial-logo-remove {
    position: absolute;
    top: -6px;
    right: -6px;
    display: flex;
    width: 21px;
    height: 21px;
    align-items: center;
    justify-content: center;
    padding: 0;
    color: #b91c1c;
    background: #fff;
    border: 1px solid #fecaca;
    border-radius: 50%;
    cursor: pointer;
    font-size: 10px;
}

.nb-filial-info {
    min-width: 0;
}

.nb-filial-info h2 {
    margin: 0;
    color: #0b1c30;
    font-size: 16px;
    font-weight: 700;
    line-height: 1.35;
    overflow-wrap: anywhere;
}

.nb-filial-meta {
    display: flex;
    flex-wrap: wrap;
    gap: 3px 12px;
    margin-top: 4px;
    color: #64748b;
    font-size: 12px;
}

.nb-filial-code {
    padding-left: 12px;
    border-left: 1px solid #cbd5e1;
}

.nb-filial-statuses {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 6px;
}

.nb-filial-badge {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    padding: 5px 8px;
    border: 1px solid transparent;
    border-radius: 6px;
    font-size: 11px;
    font-weight: 600;
    line-height: 1.2;
    white-space: nowrap;
}

.nb-filial-badge .fa-circle {
    font-size: 6px;
}

.nb-filial-badge--production,
.nb-filial-badge--active {
    color: #047857;
    background: #ecfdf5;
    border-color: #a7f3d0;
}

.nb-filial-badge--homologation,
.nb-filial-badge--pending {
    color: #b45309;
    background: #fffbeb;
    border-color: #fde68a;
}

.nb-filial-badge--expired {
    color: #b91c1c;
    background: #fef2f2;
    border-color: #fecaca;
}

.nb-filial-badge--neutral {
    color: #475569;
    background: #f1f5f9;
    border-color: #cbd5e1;
}

.nb-filial-actions {
    display: flex;
    align-items: center;
    gap: 8px;
}

.nb-filial-action .btn-group,
.nb-filial-action .btn-group > div {
    width: 100%;
}

.nb-filial-action a.btn {
    display: block;
    margin-right: 0 !important;
    white-space: nowrap;
}

@media (max-width: 991.98px) {
    .nb-filial-card-main {
        grid-template-columns: minmax(0, 1fr) auto;
        gap: 12px 16px;
    }

    .nb-filial-identity {
        grid-column: 1 / -1;
    }
}

@media (max-width: 575.98px) {
    .nb-filial-card {
        padding: 13px;
    }

    .nb-filial-card-main {
        grid-template-columns: minmax(0, 1fr);
        gap: 12px;
    }

    .nb-filial-statuses {
        grid-column: 1;
    }

    .nb-filial-actions {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        grid-column: 1;
    }

    .nb-filial-action a.btn {
        width: 100%;
        padding-right: 7px;
        padding-left: 7px;
        white-space: normal;
    }
}
</style>



// WEBPACK FOOTER //
// src/forms/filial-list.vue